import { useState, useEffect, useContext } from "react";
import Canvas from "./Canvas";
import HtmlPreview from "./HtmlPreview";
import "./Editor.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../../../Context/GlobalContext";
import SettingsPanel from "./SettingsPannel";
import Toolbar from "./Toolbar";
import NoIndex from "../../../../../components/NoIndex";

const HtmlEditor = () => {
  const { setGeneratedHTML } = useContext(GlobalContext);

  const navigate = useNavigate();

  const defaultBox = {
    id: 1,
    type: "box",
    x: 20,
    y: 60,
    width: 300,
    height: 200,
    background: "#662c2c",
    borderRadius: 10,
    padding: 10,
    zIndex: 1,
  };

  const [elements, setElements] = useState([defaultBox]);

  const [selectedId, setSelectedId] = useState(defaultBox.id);

  const [history, setHistory] = useState([]);

  const [historyIndex, setHistoryIndex] = useState(-1);

  const [previewMode, setPreviewMode] = useState(false);

  const [generateHTML, setGenerateHTML] = useState(false);

  /* =========================================================
     HISTORY
  ========================================================= */

  useEffect(() => {
    setHistory((prev) => {
      const snapshot = JSON.parse(JSON.stringify(elements));

      const updated = prev.slice(0, historyIndex + 1);

      updated.push(snapshot);

      if (updated.length > 20) {
        updated.shift();
      }

      setHistoryIndex(updated.length - 1);

      return updated;
    });
  }, [elements]);

  /* =========================================================
     UNDO
  ========================================================= */

  const undo = () => {
    if (historyIndex <= 0) return;

    const newIndex = historyIndex - 1;

    setHistoryIndex(newIndex);

    setElements(JSON.parse(JSON.stringify(history[newIndex])));
  };

  useEffect(() => {
    const handleUndo = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "z") {
        e.preventDefault();

        undo();
      }
    };

    window.addEventListener("keydown", handleUndo);

    return () => window.removeEventListener("keydown", handleUndo);
  }, [historyIndex, history]);

  /* =========================================================
     GENERATE SUCCESS
  ========================================================= */

  const handleGenerated = () => {
    toast.success("HTML Generated");

    navigate("/inventory/banner/create-new-banner");
  };

  return (
    <>
      <NoIndex />

      <div className="editor-cont montserrat-font-1">
        {/* HEADER */}

        <div className="ed-he montserrat-font-1">
          <h2>Banner Editor</h2>

          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <button
              className="gen-btn"
              onClick={() => setPreviewMode((prev) => !prev)}
            >
              {previewMode ? "Edit Mode" : "Preview"}
            </button>

            <button
              className="gen-btn"
              onClick={() => {
                setGenerateHTML(true);
              }}
            >
              Generate
            </button>
          </div>
        </div>

        {/* TOOLBAR */}

        <Toolbar
          elements={elements}
          setElements={setElements}
          selectedId={selectedId}
          previewMode={previewMode}
        />

        {/* MAIN */}

        <div className="edt-main">
          <Canvas
            elements={elements}
            setElements={setElements}
            selectedId={previewMode ? null : selectedId}
            setSelectedId={setSelectedId}
            previewMode={previewMode}
          />

          {!previewMode && (
            <SettingsPanel
              elements={elements}
              setElements={setElements}
              selectedId={selectedId}
            />
          )}
        </div>

        {/* HTML GENERATOR */}

        <HtmlPreview
          elements={elements}
          generateHTML={generateHTML}
          setGenerateHTML={setGenerateHTML}
          setGeneratedHTML={setGeneratedHTML}
          onGenerated={handleGenerated}
        />
      </div>
    </>
  );
};

export default HtmlEditor;
